<template>
    <div>

        <v-data-table :loading="isLoading"
                      :headers="headers"
                      :items="allList" sort-by="calories" class="elevation-1" hide-default-footer>
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Thumbnail</v-toolbar-title>
                    <v-divider class="mx-4" inset vertica></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark
                           class="mb-2"
                           v-on:click="newItem()">New Thumbnail
                    </v-btn>
                    <v-dialog v-model="addEditDialog" max-width="60%">
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6" >
                                            <v-text-field :rules="[rules.required]" v-model="editedItem.name"
                                                          label="Name"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" >
                                            <v-file-input @change="thumbnailChange"
                                                          accept="image/*"
                                                          :rules="[rules.required]"
                                                          placeholder="Select a cover art file"
                                                          label="File"
                                                          ref="fileUpload"
                                                          outlined
                                                          show-size
                                                          v-if="!isInEditMode"
                                                        >
                                            </v-file-input>

                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>

                <v-text-field
                        v-on:keyup.enter="searchAll"
                        v-model="search"
                        label="Search"
                        single-line
                        hide-details
                        class="pb-3 px-3"
                ></v-text-field>
            </template>


            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="downloadItem(item)"
                >
                    mdi-download
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
        </v-data-table>
        <pagination :page="page" :total-page="totalPage" @paginate="paginate($event)"></pagination>
    </div>
</template>

<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex'
    import Pagination from '../../components/Pagination'
    import {CommonService, ThumbnailService} from "../../services";

    export default {
        name: "ThumbnailPanel",
        components: {
            Pagination
        },
        data: () => ({
            loading: false,
            search: '',
            rules: {
                required: value => !!value || 'Required.'
            },
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: true,
                    value: 'name',
                },
                {text: 'Actions', value: 'actions', sortable: false},
            ],
            editedIndex: -1,
            editedItem: {
                parseItem: null,
                name: '',
                thumbnail: null,
                size: 0
            },
            defaultItem: {
                parseItem: null,
                name: '',
                thumbnail: null,
                size: 0
            },
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Thumbnail' : 'Edit Thumbnail'
            },
            page() {
                return this.getPagination().page;
            },
            perPage() {
                return this.getPagination().perPage;
            },
            totalPage() {
                return this.getPagination().totalPage;
            },
            allList() {
                return this.getAll();
            },
            isLoading() {
                return this.getLoading()
            },
            isInEditMode(){
                return this.editedIndex > -1
            },
            addEditDialog: {
                get() {
                    return this.showAddEditDialog();
                },
                set(value) {
                    this.setShowAddEditDialog(value);
                }
            }
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },
        created() {
            this.initialize()
        },
        methods: {
            ...mapMutations({
                setShowAddEditDialog: 'thumbnail/SHOW_ADD_EDIT_DIALOG'
            }),
            ...mapGetters({
                getPagination: 'thumbnail/getPagination',
                getLoading: 'thumbnail/getLoading',
                getAll: 'thumbnail/getAll',
                showAddEditDialog: 'thumbnail/showAddEditDialog'
            }),
            ...mapActions({
                requestAll: 'thumbnail/requestAll',
                setPage: 'thumbnail/setPage',
                setSearch: 'thumbnail/setSearch',
                setSave: 'thumbnail/setSave',
                setEdit: 'thumbnail/setEdit'
            }),
            initialize() {
                this.requestAll();
            },
            newItem() {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.setShowAddEditDialog(true);
            },
            editItem(item) {
                this.editedIndex = this.allList.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.setShowAddEditDialog(true)
            },
            close() {
                this.setShowAddEditDialog(false);
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            },
            save() {

                if(this.editedItem.size > 1000000){
                    CommonService.showErrorDialog("File Size Exceeded");
                    return;
                }

                if (this.editedIndex > -1) {
                    if (this.editedItem.name.length === 0) {
                        return;
                    }
                    this.setEdit({itemToEdit: this.editedItem, itemIndex: this.editedIndex});
                } else {
                    if (this.editedItem.name.length === 0) {
                        return;
                    }
                    this.setSave(this.editedItem);
                }
            },
            paginate(page) {
                this.setPage(page);
            },
            searchAll() {
                this.setSearch(this.search);
            },
            thumbnailChange(thumbnail) {
                if(thumbnail === undefined){
                    this.editedItem = Object.assign({}, this.defaultItem);
                }else{
                    this.editedItem.name = thumbnail.name;
                    this.editedItem.thumbnail = thumbnail;
                    this.editedItem.size = thumbnail.size;
                }
            },
            downloadItem(item){
                let fileUrl = item.thumbnail.url();
                let fileName = item.thumbnail.name();
                ThumbnailService.download(fileUrl, fileName);
            }
        }
    }
</script>

<style scoped>

</style>